"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _pastCalendarPanel = _interopRequireDefault(require("./past-calendar-panel"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = require("./constructed-form.props/constructed-form.defaultProps");
var _constructedForm3 = require("./constructed-form.props/constructed-form.propTypes");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /**
 * ## DatePicker - component
 *
 * Some really cool piece of description goes here.
 */ // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var getDelimiter = function getDelimiter(format) {
  return format.indexOf('-') > -1 ? '-' : '/';
};

// This function takes the first sunday after epoch and creates a string of letters representing the days of the week in a specific Locale
var makeDayNames = function makeDayNames(epochSunday, localeCode) {
  return [0, 1, 1, 1, 1, 1, 1].map(function (day) {
    return new Date(epochSunday.setDate(epochSunday.getDate() + day)).toLocaleString(localeCode, {
      weekday: 'narrow'
    });
  });
};

// This function iterates through 12 indices to make an array of local month names
var makeMonthNames = function makeMonthNames(epochSunday, localeCode) {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (monthName) {
    epochSunday.setMonth(monthName);
    return epochSunday.toLocaleString(localeCode, {
      month: 'long'
    });
  });
};
var compareDates = function compareDates(date1, date2) {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
var pad = function pad(n) {
  // eslint-disable-next-line
  return n < 10 && n.length < 2 ? "0" + n : n;
};
var prePadDateString = function prePadDateString(dateString, format) {
  // eslint-disable-next-line
  if (dateString === '' || dateString.length < 8) {
    return dateString;
  }
  var delimiter = getDelimiter(format);
  var stringSections = dateString.split(/\/|-/);
  if (delimiter === '/') {
    return pad(stringSections[0]) + "/" + pad(stringSections[1]
    // eslint-disable-next-line
    ) + "/" + pad(stringSections[2]);
  }
  if (delimiter === '-') {
    return pad(stringSections[0]) + "-" + pad(stringSections[1])
    // eslint-disable-next-line
    + "-" + pad(stringSections[2]);
  }
  return dateString;
};
var getDateSections = function getDateSections(dateString, format) {
  if (dateString && format === 'mm/dd/yyyy') {
    return {
      year: dateString.slice(-4),
      //eslint-disable-line
      month: dateString.slice(0, 2),
      //eslint-disable-line
      day: dateString.slice(3, 5),
      //eslint-disable-line
      delimeter: '/'
    };
  }
  if (dateString && format === 'dd-mm-yyyy') {
    return {
      year: dateString.slice(-4),
      //eslint-disable-line
      month: dateString.slice(3, 5),
      //eslint-disable-line
      day: dateString.slice(0, 2),
      //eslint-disable-line
      delimeter: '-'
    };
  }
  return dateString;
};
var isSameArray = function isSameArray(xs, ys) {
  return xs.length === ys.length ? xs.filter(function (x, i) {
    return x !== ys[i];
  }).length === 0 : false;
};
var PastDatePicker = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(PastDatePicker, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  PastDatePicker.resourceType = function resourceType() {
    return 'DatePickerField_1_0_0';
  };
  PastDatePicker.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var dateString = state.dateString,
      isOverField = state.isOverField;
    if (dateString !== '' && isOverField) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverField: false
      });
    }
    if (dateString === '' && !isOverField) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverField: true
      });
    }
    return null;
  };
  function PastDatePicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var constraints = props.data.constraints,
      config = props.config,
      value = props.value;
    var dateString = constraints[0] ? constraints[0].displayFormat : config.dateDisplayFormat;
    var activeDate = value ? _this.stringToDate(dateString) : new Date();
    _this.state = {
      activeDate: activeDate,
      browseDate: activeDate,
      dateString: '',
      pickerExpanded: false,
      keyboardAccess: false,
      isOverField: true
    };
    _this.clickDateButtonHandler = _this.clickDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusDateButtonHandler = _this.focusDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.monthSelectionHandler = _this.monthSelectionHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.yearSelectionHandler = _this.yearSelectionHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateTyping = _this.handleDateTyping.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateInputFocus = _this.handleDateInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateInputBlur = _this.handleDateInputBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setWrapper = _this.setWrapper.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = PastDatePicker.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // eslint-disable-next-line
    document.addEventListener('mousedown', this.handleClick, false);
    this.wrapperRef.addEventListener('keydown', this.handleKeyPress, false);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this$props = this.props,
      errorMessages = _this$props.errorMessages,
      value = _this$props.value;
    var _this$state = this.state,
      activeDate = _this$state.activeDate,
      browseDate = _this$state.browseDate,
      pickerExpanded = _this$state.pickerExpanded;
    return nextProps.value !== value || !isSameArray(nextProps.errorMessages, errorMessages) || !compareDates(nextState.activeDate, activeDate) || !compareDates(nextState.browseDate, browseDate) || nextState.pickerExpanded !== pickerExpanded;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    // eslint-disable-next-line
    document.removeEventListener('mousedown', this.handleClick, false);
    this.wrapperRef.removeEventListener('keydown', this.handleKeyPress, false);
  };
  _proto.handleDateTyping = function handleDateTyping(e, datePickerFieldName) {
    this.setDateString(e.target.value, datePickerFieldName);
  };
  _proto.handleKeyUp = function handleKeyUp(e) {
    // eslint-disable-next-line
    if (e.which !== 9) {
      e.preventDefault();
    }
    var browseDate = this.state.browseDate;
    var updatedBrowseDate = new Date(browseDate);
    var activation = 'browse';
    switch (e.which) {
      case 37:
        // eslint-disable-line
        updatedBrowseDate.setDate(browseDate.getDate() - 1);
        break;
      case 38:
        // eslint-disable-line
        updatedBrowseDate.setDate(browseDate.getDate() - 7); // eslint-disable-line
        break;
      case 39:
        // eslint-disable-line
        updatedBrowseDate.setDate(browseDate.getDate() + 1);
        break;
      case 40:
        // eslint-disable-line
        updatedBrowseDate.setDate(browseDate.getDate() + 7); // eslint-disable-line
        break;
      case 13:
        // eslint-disable-line
        activation = 'active';
        break;
      case 32:
        // eslint-disable-line
        activation = 'active';
        break;
      default:
        // eslint-disable-line
        activation = 'browse';
    }
    if (activation === 'active') {
      this.setActiveDate(updatedBrowseDate);
    } else {
      this.setBrowseDate(updatedBrowseDate);
    }
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    // eslint-disable-next-line
    if (e.which !== 9) {
      e.preventDefault();
    }
    var keyboardAccess = this.state.keyboardAccess;
    if (!keyboardAccess) {
      this.setKeyboardAccess(true);
    }
  };
  _proto.handleDateInputFocus = function handleDateInputFocus() {
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        pickerExpanded: true
      });
    });
  };
  _proto.handleDateInputBlur = function handleDateInputBlur(e) {
    var _this$props2 = this.props,
      handleFieldBlur = _this$props2.handleFieldBlur,
      id = _this$props2.id;
    var activeDate = this.state.activeDate;
    if (handleFieldBlur) {
      handleFieldBlur(activeDate, id, [e.target.className.includes('error') ? 'error' : '']);
    }
  };
  _proto.handleClick = function handleClick(e) {
    var pickerExpanded = this.state.pickerExpanded;

    // This function is watching an event on the document to collapse the date picker, push data to parent state and validate
    if (this.wrapperRef.contains(e.target) || pickerExpanded === false) {
      return;
    }
    this.checkAndUpdateInput();
    this.collapsePicker();
  };
  _proto.handleKeyPress = function handleKeyPress(e) {
    var pickerExpanded = this.state.pickerExpanded;

    // This is doing the same as the click hanlder above, just for when users press the escape key
    // eslint-disable-next-line
    if (e.keyCode !== 27 || pickerExpanded === false) {
      return;
    }
    this.checkAndUpdateInput();
    this.collapsePicker();
  };
  _proto.setBrowseDate = function setBrowseDate(updatedBrowseDate) {
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        browseDate: updatedBrowseDate
      });
    });
  };
  _proto.setKeyboardAccess = function setKeyboardAccess(keyboardAccessState) {
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        keyboardAccess: keyboardAccessState
      });
    });
  };
  _proto.setDateString = function setDateString(updatedDateString, datePickerFieldName) {
    var _this2 = this;
    this.setState(function () {
      return {
        dateString: updatedDateString
      };
    }, function () {
      var dateString = _this2.state.dateString;
      var _this2$props = _this2.props,
        checkRequired = _this2$props.checkRequired,
        data = _this2$props.data,
        updateErrors = _this2$props.updateErrors,
        handleFieldChange = _this2$props.handleFieldChange,
        id = _this2$props.id,
        validateAllConstraints = _this2$props.validateAllConstraints;
      var datePickerFieldRequired = data.datePickerFieldRequired,
        constraints = data.constraints;
      var required = checkRequired(dateString, datePickerFieldRequired);
      var errors = validateAllConstraints(dateString, constraints);
      updateErrors(id, [required].concat(errors));
      handleFieldChange(id, dateString, datePickerFieldName); // updating the parent state
    });
  }

  // Callback function to create a ref for the date picker
  ;
  _proto.setWrapper = function setWrapper(node) {
    this.wrapperRef = node;
  };
  _proto.setActiveDate = function setActiveDate(updatedActiveDate) {
    var _this3 = this;
    this.setState(function () {
      return {
        activeDate: updatedActiveDate,
        browseDate: updatedActiveDate,
        dateString: _this3.getPrettyDate(updatedActiveDate),
        pickerExpanded: false
      };
    }, function () {
      var dateString = _this3.state.dateString;
      var _this3$props = _this3.props,
        checkRequired = _this3$props.checkRequired,
        data = _this3$props.data,
        updateErrors = _this3$props.updateErrors,
        handleFieldChange = _this3$props.handleFieldChange,
        id = _this3$props.id,
        validateAllConstraints = _this3$props.validateAllConstraints;
      var datePickerFieldRequired = data.datePickerFieldRequired,
        constraints = data.constraints;
      var required = checkRequired(dateString, datePickerFieldRequired);
      var errors = validateAllConstraints(dateString, constraints);
      updateErrors(id, [required].concat(errors));
      handleFieldChange(id, dateString); // updating the parent state
    });
  };
  _proto.getPrettyDate = function getPrettyDate(date) {
    var data = this.props.data;
    var format = data.constraints[0].displayFormat || 'mm/dd/yyyy';
    var delimiter = getDelimiter(format);
    var dateSections = format.split(/\/|-/);
    var dateObj = {
      dd: date.getDate(),
      mm: date.getMonth() + 1,
      yyyy: date.getFullYear()
    };
    return prePadDateString("" + dateObj[dateSections[0]] + delimiter + dateObj[dateSections[1]]
    // eslint-disable-next-line
    + delimiter + dateObj[dateSections[2]], delimiter);
  };
  _proto.clickDateButtonHandler = function clickDateButtonHandler() {
    var _this4 = this;
    return function (e, selectedDate) {
      e.preventDefault();
      if (selectedDate) {
        _this4.setActiveDate(selectedDate);
      }
    };
  };
  _proto.focusDateButtonHandler = function focusDateButtonHandler(e, selectedDate) {
    if (selectedDate) {
      this.setBrowseDate(selectedDate);
    }
  };
  _proto.monthSelectionHandler = function monthSelectionHandler(month, selectedDate) {
    var newDate = new Date(new Date(selectedDate).setMonth(month));
    this.setBrowseDate(newDate);
  };
  _proto.yearSelectionHandler = function yearSelectionHandler(year, selectedDate) {
    var newDate = new Date(new Date(selectedDate).setFullYear(year));
    this.setBrowseDate(newDate);
  };
  _proto.validate = function validate(value) {
    var _this$props3 = this.props,
      checkRequired = _this$props3.checkRequired,
      validateAllConstraints = _this$props3.validateAllConstraints,
      updateErrors = _this$props3.updateErrors,
      id = _this$props3.id,
      data = _this$props3.data;
    var required = checkRequired(value, data.datePickerFieldRequired);
    var errors = validateAllConstraints(value, data.constraints);
    updateErrors(id, [required].concat(errors));
  };
  _proto.stringToDate = function stringToDate(dateString) {
    if (!dateString || dateString === '') {
      return 'invalid date';
    }
    var data = this.props.data;
    var dateParts = getDateSections(dateString, data.constraints[0].displayFormat);
    var dt = new Date();
    dt.setFullYear(Number(dateParts.year));
    dt.setMonth(Number(dateParts.month) - 1); // because january is month 0
    dt.setDate(Number(dateParts.day));
    return dt;
  }

  // This function will be fired each time someone clicks on the field and clicks off or hits escape
  ;
  _proto.checkAndUpdateInput = function checkAndUpdateInput() {
    var _this5 = this;
    var _this$props4 = this.props,
      data = _this$props4.data,
      validateAllConstraints = _this$props4.validateAllConstraints,
      handleFieldChange = _this$props4.handleFieldChange,
      id = _this$props4.id;
    var _this$state2 = this.state,
      dateString = _this$state2.dateString,
      activeDate = _this$state2.activeDate;

    // The prePadDateString will take the user inputed date string, and prepend 0's to the date and month
    var paddedDateString = prePadDateString(dateString, data.constraints[0].displayFormat);
    // The stringToDate will turn padded string into a date object to be operated on
    var inputDate = this.stringToDate(paddedDateString);

    // validateAllConstraints will return an array of errors based on a string
    var errors = validateAllConstraints(paddedDateString, data.constraints);
    // We will check the errors array for an error, if there are any we run the validate function
    // to update the parent state and show an error message and also update the parent state
    // with the value the user entered
    // eslint-disable-next-line
    errors.filter(function (error) {
      return error !== '';
    }).length === 0 ? !compareDates(activeDate, inputDate) && this.setActiveDate(inputDate) : function () {
      _this5.validate(paddedDateString);
      handleFieldChange(id, paddedDateString);
    }();
  };
  _proto.collapsePicker = function collapsePicker() {
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        pickerExpanded: false
      });
    });
  };
  _proto.renderPickerBox = function renderPickerBox() {
    var _this$props5 = this.props,
      theme = _this$props5.theme,
      value = _this$props5.value,
      config = _this$props5.config,
      id = _this$props5.id,
      data = _this$props5.data;
    var _data$weekStartDay = data.weekStartDay,
      weekStartDay = _data$weekStartDay === void 0 ? 0 : _data$weekStartDay;
    var _this$state3 = this.state,
      browseDate = _this$state3.browseDate,
      pickerExpanded = _this$state3.pickerExpanded,
      keyboardAccess = _this$state3.keyboardAccess;
    var activeDate = this.stringToDate(value) instanceof Date && !Number.isNaN(this.stringToDate(value)) ? this.stringToDate(value) : new Date();

    // Setup for calendar drop down, getting a localized month name and week day letters
    var previousMonth = new Date(browseDate);
    var nextMonth = new Date(browseDate);
    var epochSunday = new Date('sunday, January 4, 1970 12:00:00 AM');
    var _config$localeCode = config.localeCode,
      localeCode = _config$localeCode === void 0 ? 'en-GB' : _config$localeCode;
    var dayNames = makeDayNames(epochSunday, localeCode);
    previousMonth.setMonth(browseDate.getMonth() - 1);
    nextMonth.setMonth(browseDate.getMonth() + 1);
    var panels = {
      previous: {
        dayNames: dayNames,
        month: previousMonth.getMonth(),
        monthName: previousMonth.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(previousMonth.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      },
      current: {
        dayNames: dayNames,
        month: browseDate.getMonth(),
        monthName: browseDate.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(browseDate.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      },
      next: {
        dayNames: dayNames,
        month: nextMonth.getMonth(),
        monthName: nextMonth.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(nextMonth.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      }
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].datePickerPanel + " " + (pickerExpanded ? _constructedForm["default"].isExpanded : '') + " " + (keyboardAccess ? _constructedForm["default"].keyboardAccess : ''),
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      tabIndex: 0,
      role: "button"
    }, /*#__PURE__*/_react["default"].createElement(_pastCalendarPanel["default"], {
      data: panels.current,
      monthNames: makeMonthNames(epochSunday, localeCode),
      clickDateButtonHandler: this.clickDateButtonHandler(id),
      focusDateButtonHandler: this.focusDateButtonHandler,
      monthSelectionHandler: this.monthSelectionHandler,
      yearSelectionHandler: this.yearSelectionHandler,
      theme: theme
    }));
  };
  _proto.render = function render() {
    var _this6 = this;
    var _this$props6 = this.props,
      errorMessages = _this$props6.errorMessages,
      theme = _this$props6.theme,
      data = _this$props6.data,
      id = _this$props6.id;
    var datePickerFieldName = data.datePickerFieldName,
      fieldLabel = data.fieldLabel,
      requiredMessage = data.requiredMessage,
      datePickerFieldRequired = data.datePickerFieldRequired;
    var _this$state4 = this.state,
      dateString = _this$state4.dateString,
      isOverField = _this$state4.isOverField;
    var allErrorMessages = errorMessages || '';
    var errors = allErrorMessages.filter(function (error) {
      return error !== '';
    });
    var constraintError = errors.length > 0 && errors[0] !== 'requiredMessage';
    // eslint-disable-next-line
    var inputId = Math.floor(Math.random() * 999);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _constructedForm["default"].formField,
      key: datePickerFieldName,
      ref: this.setWrapper
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: datePickerFieldName + "-" + inputId,
      className: _constructedForm["default"].fieldLabel + " " + theme.labelSmall + " " + (isOverField ? _constructedForm["default"].isOverField : '')
    }, fieldLabel && fieldLabel.trim(), datePickerFieldRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), /*#__PURE__*/_react["default"].createElement("input", {
      className: theme.inputsAndOptions + " " + _constructedForm["default"].textField + " " + (errors.length !== 0 ? _constructedForm["default"].error : ''),
      name: datePickerFieldName,
      id: datePickerFieldName + "-" + inputId,
      type: "text",
      required: datePickerFieldRequired,
      "aria-invalid": constraintError,
      "aria-describedby": errors.length !== 0 && datePickerFieldName + "-error-" + id.join('-'),
      autoComplete: "nonOffString-" + inputId,
      value: dateString,
      onChange: function onChange(e) {
        return _this6.handleDateTyping(e, datePickerFieldName);
      },
      onFocus: this.handleDateInputFocus,
      onBlur: this.handleDateInputBlur
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.mmcIconCalendar + " " + _constructedForm["default"].calendarIconPosition
    }), this.renderPickerBox(), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      errorLabel: datePickerFieldName + "-error-" + id.join('-')
    }) : errorMessages.filter(function (error) {
      return error !== '';
    }).map(function (message) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: message,
        message: message,
        theme: theme,
        errorLabel: datePickerFieldName + "-error-" + id.join('-')
      });
    }));
  };
  return PastDatePicker;
}(_react["default"].Component);
exports["default"] = PastDatePicker;
PastDatePicker.displayName = 'PastDatePicker';
PastDatePicker.defaultProps = {
  data: _constructedForm2.PAST_DATE_PICKER_DEFAULT_PROPS.formComponents[0],
  // eslint-disable-line
  theme: {}
};